const GRID = {
	gap: 12,
	overscan: 6,
	estimatedItemHeight: 200,
	gridBreakpoints: [
		{ min: 1700, cols: 4 },
		{ min: 1300, cols: 3 },
		{ min: 600, cols: 3 },
		{ min: 0, cols: 2 },
	],
};

const LIST = {
	gap: 12,
	overscan: 6,
	estimatedItemHeight: 100,
	gridBreakpoints: [{ min: 0, cols: 1 }],
};

export default {
	GRID,
	LIST,
};
